<template>
    <div>
        <!-- 顶部标签导航 -->
        <el-tabs v-model="activeTab" type="card" tab-position="top" class="carousel-tabs" @tab-click="handleTabClick">
            <el-tab-pane label="积分查询回复设置" name="query"></el-tab-pane>
            <el-tab-pane label="积分排行回复设置" name="rank"></el-tab-pane>
            <el-tab-pane label="积分流水回复设置" name="flow"></el-tab-pane>
        </el-tabs>

        <!-- 设置页面 -->
        <div v-if="activeTab === 'query'">
            <div class="carousel-banner">
                <div class="carousel-banner-title">积分查询回复设置</div>
            </div>
            <el-card class="carousel-setting-card">

                <el-form label-width="100px" style="max-width: 500px; margin: 0 auto;">


                    <el-form-item label="是否启用：">
                        <el-switch v-model="ReplyPointsconfig.isEnablePoint" class="big-switch" />
                    </el-form-item>


                    <el-form-item label="关键词">
                        <div class="keyword-tags-input">
                            <el-tag v-for="tag in ReplyPointsconfig.pointKeywordList" :key="tag" closable
                                :disable-transitions="false" @close="handleKeywordTagClose(tag, 'pointKeywordList')">
                                {{ tag }}
                            </el-tag>
                            <input type="text" class="keyword-new-tag-input" v-model="keyword_input"
                                @keyup.enter="handleKeywordInputConfirm('pointKeywordList')" placeholder="输入后按回车" />
                        </div>
                    </el-form-item>



                    <el-form-item prop="contentType" label-width="10px">
                        <div class="reply-type-horizontal">
                            <div class="type-select-container">
                                <span style="white-space: nowrap; margin-right: 10px;">回复内容</span>
                                <el-select v-model="ReplyPointsconfig.pointMsgType" placeholder="请选择内容类型"
                                    style="width: 150px;" popper-class="reply-type-dropdown">
                                    <el-option label="文本内容" value="text"></el-option>
                                    <el-option label="图片" value="photo"></el-option>
                                    <el-option label="视频" value="video"></el-option>
                                </el-select>
                            </div>
                            <div class="media-url-container"
                                v-if="ReplyPointsconfig.pointMsgType === 'photo' || ReplyPointsconfig.pointMsgType === 'video'">
                                <span style="white-space: nowrap; margin-right: 10px; color: #606266; font-size: 14px;">
                                    {{ { photo: '图片', video: '视频' }[ReplyPointsconfig.pointMsgType] }}地址：
                                </span>
                                <el-input v-model="ReplyPointsconfig.pointFileUrl"
                                    :placeholder="`请输入${{ photo: '图片', video: '视频' }[ReplyPointsconfig.pointMsgType]}的URL地址`"
                                    style="flex: 1; min-width: 200px;" />
                            </div>
                        </div>
                    </el-form-item>



                    <el-form-item prop="replaytext" label="" label-width="120px">
                        <div :key="editorMyLinkKey" class="html-editor">
                            <!-- 简单的 HTML 工具栏 -->
                            <div class="html-toolbar">
                                <button @click="insertHtmlMyLink('<b>', '</b>')" type="button" title="加粗">
                                    <strong>B</strong>
                                </button>
                                <button @click="insertHtmlMyLink('<i>', '</i>')" type="button" title="斜体">
                                    <em>I</em>
                                </button>
                                <button @click="insertHtmlMyLink('<u>', '</u>')" type="button" title="下划线">
                                    <u>U</u>
                                </button>
                                <button @click="insertHtmlMyLink('<br>')" type="button" title="换行">
                                    换行
                                </button>
                                <span class="divider">|</span>
                                <button @click="insertHtmlMyLink('<h1>', '</h1>')" type="button" title="标题1">
                                    H1
                                </button>
                                <button @click="insertHtmlMyLink('<h2>', '</h2>')" type="button" title="标题2">
                                    H2
                                </button>
                                <span class="divider">|</span>
                                <button @click="insertHtmlMyLink('<ul><li>', '</li></ul>')" type="button" title="无序列表">
                                    • 列表
                                </button>
                                <button @click="insertHtmlMyLink('<ol><li>', '</li></ol>')" type="button" title="有序列表">
                                    1. 列表
                                </button>
                                <span class="divider">|</span>
                                <button @click="toggleModeMyLink" type="button"
                                    :title="isSourceModeMyLink ? '切换到可视化模式' : '切换到源码模式'"
                                    :class="{ 'is-active': isSourceModeMyLink }">
                                    {{ isSourceModeMyLink ? '可视' : '源码' }}
                                </button>
                            </div>
                            <!-- 编辑器内容区域 -->
                            <div class="editor-content-area">
                                <!-- 可视化编辑模式 -->
                                <div v-if="!isSourceModeMyLink" ref="visualEditorMyLink" class="visual-editor"
                                    contenteditable="true" @input="handleVisualInputMyLink"
                                    @compositionstart="handleCompositionStartMyLink"
                                    @compositionend="handleCompositionEndMyLink" @paste="handlePasteMyLink"
                                    @keydown="handleKeydownMyLink">
                                </div>
                                <!-- 源码编辑模式 -->
                                <el-input v-if="isSourceModeMyLink" ref="htmlTextareaMyLink"
                                    v-model="ReplyPointsconfig.pointHtml" type="textarea" :rows="8"
                                    placeholder="请输入内容，支持HTML标签..." class="html-textarea" />
                            </div>
                        </div>
                    </el-form-item>


                    <div class="variable-help-text">
                        <span class="variable-item"><code>{pointAlias}</code>为积分别名，</span>
                        <span class="variable-item"><code>{pointBalance}</code>表示积分余额，</span>
                        <span class="variable-item"><code>{userRank}</code>表示用户排名，</span>
                    </div>



                    <!-- 附加按钮 -->
                    <el-form-item prop="buttons" label="附加按钮" label-width="80px">
                        <!-- 按钮行列表 -->
                        <div v-if="ReplyPointsconfig.pointMsgBtnList.length > 0" class="button-rows-list">
                            <div v-for="(row, rowIndex) in ReplyPointsconfig.pointMsgBtnList"
                                :key="`row-${rowIndex}-${JSON.stringify(row)}`" class="button-row-wrapper"
                                @dragover="handleDragOver" @drop="handleDrop($event, rowIndex, 'success')"
                                :class="{ 'drag-over': draggedRowIndex !== null && draggedRowIndex !== rowIndex }">
                                <!-- 灰色按钮容器 -->
                                <div class="gray-buttons-container">
                                    <div v-for="(button, btnIndex) in row" :key="btnIndex" class="button-item">
                                        {{ button.text || '按钮' }}
                                        <div class="button-actions">
                                            <div class="button-action-icon edit-icon"
                                                @click="editButton(rowIndex, btnIndex, 'success')" title="编辑按钮">
                                                <el-icon>
                                                    <Edit />
                                                </el-icon>
                                            </div>
                                            <div class="button-action-icon delete-icon"
                                                @click="removeButton(rowIndex, btnIndex, 'success')" title="删除按钮">
                                                <el-icon>
                                                    <Delete />
                                                </el-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 只有当行数 >= 1 时，才显示"本行新增一个按钮" -->
                                <div v-if="ReplyPointsconfig.pointMsgBtnList.length >= 1" class="add-button-container">
                                    <button @click="showAddButtonDialog(rowIndex, 'success')" type="button"
                                        class="add-to-row-button">
                                        + 本行新增一个按钮
                                    </button>
                                </div>
                                <!-- 右侧拖拽图标 -->
                                <div class="drag-icon-container" :title="'拖拽移动第' + (rowIndex + 1) + '行'"
                                    draggable="true" @dragstart="handleDragStart(rowIndex)" @dragend="handleDragEnd">
                                    <el-icon class="drag-icon">
                                        <Rank />
                                    </el-icon>
                                </div>
                            </div>
                        </div>

                        <!-- 新增一行按钮 -->
                        <div class="button-controls">
                            <button @click="showAddButtonDialog(-1, 'success')" type="button" class="add-row-button">
                                + 新增一行按钮
                            </button>
                        </div>
                    </el-form-item>

                    <!-- 添加按钮对话框 -->
                    <el-dialog v-model="buttonDialogVisible" :title="getDialogTitle()" width="600px"
                        :close-on-click-modal="false" destroy-on-close>
                        <el-form :model="buttonForm" :rules="buttonRules" ref="buttonFormRef" label-width="80px">
                            <el-form-item label="按钮文字" prop="text">
                                <el-input v-model="buttonForm.text" placeholder="请输入按钮文字" />
                            </el-form-item>
                            <el-form-item label="链接" prop="url">
                                <el-input v-model="buttonForm.url" placeholder="请输入http(s)://开头的链接或tg://开头的链接" />
                            </el-form-item>
                        </el-form>
                        <template #footer>
                            <div class="dialog-footer">
                                <el-button @click="buttonDialogVisible = false">取消</el-button>
                                <el-button type="primary" @click="confirmAddButton">确定</el-button>
                            </div>
                        </template>
                    </el-dialog>



                    <el-form-item prop="deleteMemo" label-width="130px">
                        <template #label>
                            <span>删除消息时间</span>
                        </template>
                        <el-select v-model="ReplyPointsconfig.pointReplyDeleteMemo" placeholder="不删除"
                            style="max-width: 400px;">
                            <el-option label="不删除" value="0"></el-option>
                            <el-option label="1秒后删除" value="1"></el-option>
                            <el-option label="3秒后删除" value="3"></el-option>
                            <el-option label="5秒后删除" value="5"></el-option>
                            <el-option label="10秒后删除" value="10"></el-option>
                            <el-option label="20秒后删除" value="20"></el-option>
                            <el-option label="30秒后删除" value="30"></el-option>
                            <el-option label="60秒后删除" value="60"></el-option>
                            <el-option label="90秒后删除" value="90"></el-option>
                            <el-option label="120秒后删除" value="120"></el-option>

                            <el-option label="5分钟后删除" value="300"></el-option>
                            <el-option label="10分钟后删除" value="600"></el-option>
                            <el-option label="15分钟后删除" value="900"></el-option>
                            <el-option label="30分钟后删除" value="1800"></el-option>
                            <el-option label="60分钟后删除" value="3600"></el-option>
                        </el-select>
                    </el-form-item>


                    <el-form-item>
                        <div style="display: flex; justify-content: space-between; width: 100%;">
                            <el-button type="primary" class="big-submit-btn" @click="saveSetting">提交</el-button>
                        </div>
                    </el-form-item>


                </el-form>
            </el-card>
        </div>

        <!-- 列表页面 -->
        <div v-else-if="activeTab === 'rank'">
            <div class="carousel-banner">
                <div class="carousel-banner-title">积分排行回复设置</div>
            </div>

            <el-card class="carousel-setting-card">

                <el-form label-width="120px" style="max-width: 500px; margin: 0 auto;">


                    <el-form-item label="是否启用：">
                        <el-switch v-model="ReplyPointsconfig.isEnable" class="big-switch" />
                    </el-form-item>


                    <el-form-item label="关键词">
                        <div class="keyword-tags-input">
                            <el-tag v-for="tag in ReplyPointsconfig.keywordList" :key="tag" closable
                                :disable-transitions="false" @close="handleKeywordTagClose(tag, 'keywordList')">
                                {{ tag }}
                            </el-tag>
                            <input type="text" class="keyword-new-tag-input" v-model="keyword_input"
                                @keyup.enter="handleKeywordInputConfirm('keywordList')" placeholder="输入后按回车" />
                        </div>
                    </el-form-item>



                    <el-form-item prop="contentType" label-width="10px">
                        <div class="reply-type-horizontal">
                            <div class="type-select-container">
                                <span style="white-space: nowrap; margin-right: 10px;">回复内容</span>
                                <el-select v-model="ReplyPointsconfig.msgType" placeholder="请选择内容类型"
                                    style="width: 150px;" popper-class="reply-type-dropdown">
                                    <el-option label="文本内容" value="text"></el-option>
                                    <el-option label="图片" value="photo"></el-option>
                                    <el-option label="视频" value="video"></el-option>
                                </el-select>
                            </div>
                            <div class="media-url-container"
                                v-if="ReplyPointsconfig.msgType === 'photo' || ReplyPointsconfig.msgType === 'video'">
                                <span style="white-space: nowrap; margin-right: 10px; color: #606266; font-size: 14px;">
                                    {{ { photo: '图片', video: '视频' }[ReplyPointsconfig.msgType] }}地址：
                                </span>
                                <el-input v-model="ReplyPointsconfig.fileUrl"
                                    :placeholder="`请输入${{ photo: '图片', video: '视频' }[ReplyPointsconfig.msgType]}的URL地址`"
                                    style="flex: 1; min-width: 200px;" />
                            </div>
                        </div>
                    </el-form-item>











                    <el-form-item prop="replaytext" label="" label-width="120px">
                        <div :key="editorSuccessKey" class="html-editor">

                            <div class="html-toolbar">
                                <button @click="insertHtmlSuccess('<b>', '</b>')" type="button" title="加粗">
                                    <strong>B</strong>
                                </button>
                                <button @click="insertHtmlSuccess('<i>', '</i>')" type="button" title="斜体">
                                    <em>I</em>
                                </button>
                                <button @click="insertHtmlSuccess('<u>', '</u>')" type="button" title="下划线">
                                    <u>U</u>
                                </button>
                                <button @click="insertHtmlSuccess('<br>')" type="button" title="换行">
                                    换行
                                </button>
                                <span class="divider">|</span>
                                <button @click="insertHtmlSuccess('<h1>', '</h1>')" type="button" title="标题1">
                                    H1
                                </button>
                                <button @click="insertHtmlSuccess('<h2>', '</h2>')" type="button" title="标题2">
                                    H2
                                </button>
                                <span class="divider">|</span>
                                <button @click="insertHtmlSuccess('<ul><li>', '</li></ul>')" type="button" title="无序列表">
                                    • 列表
                                </button>
                                <button @click="insertHtmlSuccess('<ol><li>', '</li></ol>')" type="button" title="有序列表">
                                    1. 列表
                                </button>
                                <span class="divider">|</span>
                                <button @click="toggleModeSuccess" type="button"
                                    :title="isSourceModeSuccess ? '切换到可视化模式' : '切换到源码模式'"
                                    :class="{ 'is-active': isSourceModeSuccess }">
                                    {{ isSourceModeSuccess ? '可视' : '源码' }}
                                </button>
                            </div>

                            <div class="editor-content-area">

                                <div v-if="!isSourceModeSuccess" ref="visualEditorSuccess" class="visual-editor"
                                    contenteditable="true" @input="handleVisualInputSuccess"
                                    @compositionstart="handleCompositionStartSuccess"
                                    @compositionend="handleCompositionEndSuccess" @paste="handlePasteSuccess"
                                    @keydown="handleKeydownSuccess">
                                </div>

                                <el-input v-if="isSourceModeSuccess" ref="htmlTextareaSuccess"
                                    v-model="ReplyPointsconfig.msgContent" type="textarea" :rows="8"
                                    placeholder="请输入内容，支持HTML标签..." class="html-textarea" />
                            </div>
                        </div>
                    </el-form-item>


                    <div class="variable-help-text">
                        <span class="variable-item"><code>{pointAlias}</code>为积分别名，</span>
                        <span class="variable-item"><code>{pointBalance}</code>表示积分余额，</span>
                        <span class="variable-item"><code>{userRank}</code>表示用户排名，</span>
                        <span class="variable-item"><code>{rankList}</code>表示排名列表</span>
                    </div>



                    <!-- 附加按钮 -->
                    <el-form-item prop="buttons" label="附加按钮" label-width="80px">
                        <!-- 按钮行列表 -->
                        <div v-if="ReplyPointsconfig.msgBtnList.length > 0" class="button-rows-list">
                            <div v-for="(row, rowIndex) in ReplyPointsconfig.msgBtnList"
                                :key="`row-${rowIndex}-${JSON.stringify(row)}`" class="button-row-wrapper"
                                @dragover="handleDragOver" @drop="handleDrop($event, rowIndex, 'success')"
                                :class="{ 'drag-over': draggedRowIndex !== null && draggedRowIndex !== rowIndex }">
                                <!-- 灰色按钮容器 -->
                                <div class="gray-buttons-container">
                                    <div v-for="(button, btnIndex) in row" :key="btnIndex" class="button-item">
                                        {{ button.text || '按钮' }}
                                        <div class="button-actions">
                                            <div class="button-action-icon edit-icon"
                                                @click="editButton(rowIndex, btnIndex, 'success')" title="编辑按钮">
                                                <el-icon>
                                                    <Edit />
                                                </el-icon>
                                            </div>
                                            <div class="button-action-icon delete-icon"
                                                @click="removeButton(rowIndex, btnIndex, 'success')" title="删除按钮">
                                                <el-icon>
                                                    <Delete />
                                                </el-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 只有当行数 >= 1 时，才显示"本行新增一个按钮" -->
                                <div v-if="ReplyPointsconfig.msgBtnList.length >= 1" class="add-button-container">
                                    <button @click="showAddButtonDialog(rowIndex, 'success')" type="button"
                                        class="add-to-row-button">
                                        + 本行新增一个按钮
                                    </button>
                                </div>
                                <!-- 右侧拖拽图标 -->
                                <div class="drag-icon-container" :title="'拖拽移动第' + (rowIndex + 1) + '行'"
                                    draggable="true" @dragstart="handleDragStart(rowIndex)" @dragend="handleDragEnd">
                                    <el-icon class="drag-icon">
                                        <Rank />
                                    </el-icon>
                                </div>
                            </div>
                        </div>

                        <!-- 新增一行按钮 -->
                        <div class="button-controls">
                            <button @click="showAddButtonDialog(-1, 'success')" type="button" class="add-row-button">
                                + 新增一行按钮
                            </button>
                        </div>
                    </el-form-item>

                    <!-- 添加按钮对话框 -->
                    <el-dialog v-model="buttonDialogVisible" :title="getDialogTitle()" width="600px"
                        :close-on-click-modal="false" destroy-on-close>
                        <el-form :model="buttonForm" :rules="buttonRules" ref="buttonFormRef" label-width="80px">
                            <el-form-item label="按钮文字" prop="text">
                                <el-input v-model="buttonForm.text" placeholder="请输入按钮文字" />
                            </el-form-item>
                            <el-form-item label="链接" prop="url">
                                <el-input v-model="buttonForm.url" placeholder="请输入http(s)://开头的链接或tg://开头的链接" />
                            </el-form-item>
                        </el-form>
                        <template #footer>
                            <div class="dialog-footer">
                                <el-button @click="buttonDialogVisible = false">取消</el-button>
                                <el-button type="primary" @click="confirmAddButton">确定</el-button>
                            </div>
                        </template>
                    </el-dialog>



                    <el-form-item prop="deleteMemo" label-width="130px">
                        <template #label>
                            <span>删除消息时间</span>
                        </template>
                        <el-select v-model="ReplyPointsconfig.replyDeleteMemo" placeholder="不删除"
                            style="max-width: 400px;">
                            <el-option label="不删除" value="0"></el-option>
                            <el-option label="1秒后删除" value="1"></el-option>
                            <el-option label="3秒后删除" value="3"></el-option>
                            <el-option label="5秒后删除" value="5"></el-option>
                            <el-option label="10秒后删除" value="10"></el-option>
                            <el-option label="20秒后删除" value="20"></el-option>
                            <el-option label="30秒后删除" value="30"></el-option>
                            <el-option label="60秒后删除" value="60"></el-option>
                            <el-option label="90秒后删除" value="90"></el-option>
                            <el-option label="120秒后删除" value="120"></el-option>

                            <el-option label="5分钟后删除" value="300"></el-option>
                            <el-option label="10分钟后删除" value="600"></el-option>
                            <el-option label="15分钟后删除" value="900"></el-option>
                            <el-option label="30分钟后删除" value="1800"></el-option>
                            <el-option label="60分钟后删除" value="3600"></el-option>
                        </el-select>
                    </el-form-item>





                    <el-form-item>
                        <div style="display: flex; justify-content: space-between; width: 100%;">
                            <el-button type="primary" class="big-submit-btn" @click="saveSetting">提交</el-button>
                        </div>
                    </el-form-item>


                </el-form>
            </el-card>

        </div>

        <div v-else-if="activeTab === 'flow'">

            <div class="carousel-banner">
                <div class="carousel-banner-title">积分流水回复设置</div>
            </div>


            <el-card class="carousel-setting-card">

                <el-form label-width="120px" style="max-width: 500px; margin: 0 auto;">


                    <el-form-item label="是否启用：">
                        <el-switch v-model="ReplyPointsconfig.isEnableLog" class="big-switch" />
                    </el-form-item>


                    <el-form-item label="关键词">
                        <div class="keyword-tags-input">
                            <el-tag v-for="tag in ReplyPointsconfig.logKeywordList" :key="tag" closable
                                :disable-transitions="false" @close="handleKeywordTagClose(tag, 'logKeywordList')">
                                {{ tag }}
                            </el-tag>
                            <input type="text" class="keyword-new-tag-input" v-model="keyword_input"
                                @keyup.enter="handleKeywordInputConfirm('logKeywordList')" placeholder="输入后按回车" />
                        </div>
                    </el-form-item>



                    <el-form-item prop="contentType" label-width="10px">
                        <div class="reply-type-horizontal">
                            <div class="type-select-container">
                                <span style="white-space: nowrap; margin-right: 10px;">回复内容</span>
                                <el-select v-model="ReplyPointsconfig.logMsgType" placeholder="请选择内容类型"
                                    style="width: 150px;" popper-class="reply-type-dropdown">
                                    <el-option label="文本内容" value="text"></el-option>
                                    <el-option label="图片" value="photo"></el-option>
                                    <el-option label="视频" value="video"></el-option>
                                </el-select>
                            </div>
                            <div class="media-url-container"
                                v-if="ReplyPointsconfig.logMsgType === 'photo' || ReplyPointsconfig.logMsgType === 'video'">
                                <span style="white-space: nowrap; margin-right: 10px; color: #606266; font-size: 14px;">
                                    {{ { photo: '图片', video: '视频' }[ReplyPointsconfig.logMsgType] }}地址：
                                </span>
                                <el-input v-model="ReplyPointsconfig.logFileUrl"
                                    :placeholder="`请输入${{ photo: '图片', video: '视频' }[ReplyPointsconfig.logMsgType]}的URL地址`"
                                    style="flex: 1; min-width: 200px;" />
                            </div>
                        </div>
                    </el-form-item>











                    <el-form-item prop="replaytext" label="" label-width="120px">
                        <div :key="editorLogKey" class="html-editor">

                            <div class="html-toolbar">
                                <button @click="insertHtmlLog('<b>', '</b>')" type="button" title="加粗">
                                    <strong>B</strong>
                                </button>
                                <button @click="insertHtmlLog('<i>', '</i>')" type="button" title="斜体">
                                    <em>I</em>
                                </button>
                                <button @click="insertHtmlLog('<u>', '</u>')" type="button" title="下划线">
                                    <u>U</u>
                                </button>
                                <button @click="insertHtmlLog('<br>')" type="button" title="换行">
                                    换行
                                </button>
                                <span class="divider">|</span>
                                <button @click="insertHtmlLog('<h1>', '</h1>')" type="button" title="标题1">
                                    H1
                                </button>
                                <button @click="insertHtmlLog('<h2>', '</h2>')" type="button" title="标题2">
                                    H2
                                </button>
                                <span class="divider">|</span>
                                <button @click="insertHtmlLog('<ul><li>', '</li></ul>')" type="button" title="无序列表">
                                    • 列表
                                </button>
                                <button @click="insertHtmlLog('<ol><li>', '</li></ol>')" type="button" title="有序列表">
                                    1. 列表
                                </button>
                                <span class="divider">|</span>
                                <button @click="toggleModeLog" type="button"
                                    :title="isSourceModeLog ? '切换到可视化模式' : '切换到源码模式'"
                                    :class="{ 'is-active': isSourceModeLog }">
                                    {{ isSourceModeLog ? '可视' : '源码' }}
                                </button>
                            </div>

                            <div class="editor-content-area">

                                <div v-if="!isSourceModeLog" ref="visualEditorLog" class="visual-editor"
                                    contenteditable="true" @input="handleVisualInputLog"
                                    @compositionstart="handleCompositionStartLog"
                                    @compositionend="handleCompositionEndLog" @paste="handlePasteLog"
                                    @keydown="handleKeydownLog">
                                </div>

                                <el-input v-if="isSourceModeLog" ref="htmlTextareaLog"
                                    v-model="ReplyPointsconfig.logHtml" type="textarea" :rows="8"
                                    placeholder="请输入内容，支持HTML标签..." class="html-textarea" />
                            </div>
                        </div>
                    </el-form-item>


                    <div class="variable-help-text">
                        <span class="variable-item"><code>{pointAlias}</code>为积分别名，</span>
                        <span class="variable-item"><code>{pointBalance}</code>表示积分余额，</span>
                        <span class="variable-item"><code>{userRank}</code>表示用户排名，</span>
                        <span class="variable-item"><code>{logList}</code>表示流水列表</span>
                    </div>



                    <!-- 附加按钮 -->
                    <el-form-item prop="buttons" label="附加按钮" label-width="80px">
                        <!-- 按钮行列表 -->
                        <div v-if="ReplyPointsconfig.logMsgBtnList.length > 0" class="button-rows-list">
                            <div v-for="(row, rowIndex) in ReplyPointsconfig.logMsgBtnList"
                                :key="`row-${rowIndex}-${JSON.stringify(row)}`" class="button-row-wrapper"
                                @dragover="handleDragOver" @drop="handleDrop($event, rowIndex, 'success')"
                                :class="{ 'drag-over': draggedRowIndex !== null && draggedRowIndex !== rowIndex }">
                                <!-- 灰色按钮容器 -->
                                <div class="gray-buttons-container">
                                    <div v-for="(button, btnIndex) in row" :key="btnIndex" class="button-item">
                                        {{ button.text || '按钮' }}
                                        <div class="button-actions">
                                            <div class="button-action-icon edit-icon"
                                                @click="editButton(rowIndex, btnIndex, 'success')" title="编辑按钮">
                                                <el-icon>
                                                    <Edit />
                                                </el-icon>
                                            </div>
                                            <div class="button-action-icon delete-icon"
                                                @click="removeButton(rowIndex, btnIndex, 'success')" title="删除按钮">
                                                <el-icon>
                                                    <Delete />
                                                </el-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 只有当行数 >= 1 时，才显示"本行新增一个按钮" -->
                                <div v-if="ReplyPointsconfig.logMsgBtnList.length >= 1" class="add-button-container">
                                    <button @click="showAddButtonDialog(rowIndex, 'success')" type="button"
                                        class="add-to-row-button">
                                        + 本行新增一个按钮
                                    </button>
                                </div>
                                <!-- 右侧拖拽图标 -->
                                <div class="drag-icon-container" :title="'拖拽移动第' + (rowIndex + 1) + '行'"
                                    draggable="true" @dragstart="handleDragStart(rowIndex)" @dragend="handleDragEnd">
                                    <el-icon class="drag-icon">
                                        <Rank />
                                    </el-icon>
                                </div>
                            </div>
                        </div>

                        <!-- 新增一行按钮 -->
                        <div class="button-controls">
                            <button @click="showAddButtonDialog(-1, 'success')" type="button" class="add-row-button">
                                + 新增一行按钮
                            </button>
                        </div>
                    </el-form-item>

                    <!-- 添加按钮对话框 -->
                    <el-dialog v-model="buttonDialogVisible" :title="getDialogTitle()" width="600px"
                        :close-on-click-modal="false" destroy-on-close>
                        <el-form :model="buttonForm" :rules="buttonRules" ref="buttonFormRef" label-width="80px">
                            <el-form-item label="按钮文字" prop="text">
                                <el-input v-model="buttonForm.text" placeholder="请输入按钮文字" />
                            </el-form-item>
                            <el-form-item label="链接" prop="url">
                                <el-input v-model="buttonForm.url" placeholder="请输入http(s)://开头的链接或tg://开头的链接" />
                            </el-form-item>
                        </el-form>
                        <template #footer>
                            <div class="dialog-footer">
                                <el-button @click="buttonDialogVisible = false">取消</el-button>
                                <el-button type="primary" @click="confirmAddButton">确定</el-button>
                            </div>
                        </template>
                    </el-dialog>



                    <el-form-item prop="deleteMemo" label-width="130px">
                        <template #label>
                            <span>删除消息时间</span>
                        </template>
                        <el-select v-model="ReplyPointsconfig.logReplyDeleteMemo" placeholder="不删除"
                            style="max-width: 400px;">
                            <el-option label="不删除" value="0"></el-option>
                            <el-option label="1秒后删除" value="1"></el-option>
                            <el-option label="3秒后删除" value="3"></el-option>
                            <el-option label="5秒后删除" value="5"></el-option>
                            <el-option label="10秒后删除" value="10"></el-option>
                            <el-option label="20秒后删除" value="20"></el-option>
                            <el-option label="30秒后删除" value="30"></el-option>
                            <el-option label="60秒后删除" value="60"></el-option>
                            <el-option label="90秒后删除" value="90"></el-option>
                            <el-option label="120秒后删除" value="120"></el-option>

                            <el-option label="5分钟后删除" value="300"></el-option>
                            <el-option label="10分钟后删除" value="600"></el-option>
                            <el-option label="15分钟后删除" value="900"></el-option>
                            <el-option label="30分钟后删除" value="1800"></el-option>
                            <el-option label="60分钟后删除" value="3600"></el-option>
                        </el-select>
                    </el-form-item>





                    <el-form-item>
                        <div style="display: flex; justify-content: space-between; width: 100%;">
                            <el-button type="primary" class="big-submit-btn" @click="saveSetting">提交</el-button>
                        </div>
                    </el-form-item>


                </el-form>
            </el-card>




        </div>

    </div>
</template>

<script>
import { Edit, Delete, Rank } from '@element-plus/icons-vue'
import api from '@/services/api'

export default {
    name: 'AutoReply',
    components: {
        Edit,
        Delete,
        Rank
    },
    data() {
        return {
            ReplyPointsconfig: {
                pointKeywordList: ["积分"],
                pointMsgType: "text",
                pointFileUrl: "",
                pointHtml: "您当前的{pointAlias}为{pointBalance}，在本群的排名为：{userRank}<br>",
                pointMsgBtnList: [],
                pointReplyDeleteMemo: "0",
                isEnablePoint: 1,
                logPageSize: 10,
                logKeywordList: ["流水"],
                logMsgType: "text",
                logFileUrl: "",
                logHtml: "您当前的{pointAlias}为{pointBalance}，最近{pointAlias}流水如下：<br>{logList}<br>",
                logMsgBtnList: [],
                logReplyDeleteMemo: "0",
                isEnableLog: 1,
                sendNum: 100,
                pageSize: 10,
                keywordList: ["积分排行", "福布斯排行"],
                msgType: "text",
                fileUrl: "",
                msgContent: "您当前的{pointAlias}为{pointBalance}，在本群的排名为：{userRank}<br><br>本群{pointAlias}榜如下： <br>{rankLinkList}<br>",
                msgBtnList: [],
                replyDeleteMemo: "60",
                memo: "",
                isEnable: 1
            },
            tableData: [],
            currentPage: 1,
            pageSize: 20,
            total: 0,
            loading: false,
            statsVisible: false,
            stats: {
                overview: null
            },
            dialogType: 'create',
            importVisible: false,
            importLoading: false,
            selectedFile: null,
            currentUserInfo: {
                userid: null,
                groupid: null,
                userBot: null
            },
            form: {
                userBot: null,
                groupid: null,
                userid: null,
                buttons: []
            },
            rules: {
                msgContent: [
                    {
                        required: true,
                        message: '请输入轮播文本内容',
                        trigger: 'blur',
                        validator: (rule, value, callback) => {

                            if (!value || value.trim() === '') {
                                callback(new Error('请输入轮播文本内容'));
                            } else {
                                callback();
                            }
                        }
                    }
                ],
                endTime: [
                    {
                        validator: (rule, value, callback) => {
                            if (value && this.form.startTime && value <= this.form.startTime) {
                                callback(new Error('结束时间必须晚于开始时间'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ]
            },
            // 富文本编辑器相关数据
            isSourceMode: false,
            isComposing: false,
            updateTimer: null,
            // 三个富文本编辑器的独立状态
            isSourceModeMyLink: false,
            isSourceModeSuccess: false,
            isSourceModeLog: false,
            editorMyLinkKey: 'myLink',
            editorSuccessKey: 'success',
            editorLogKey: 'log',
            // 关键词输入
            keyword_input: '',
            // 按钮相关数据
            buttonForm: {
                text: '',
                url: ''
            },
            buttonDialogVisible: false,
            editingButtonRowIndex: -1,
            editingButtonIndex: -1,
            currentRowIndex: -1,
            draggedRowIndex: null,

            buttonRules: {
                text: [
                    { required: true, message: '请输入按钮文字', trigger: 'blur' }
                ],
                url: [
                    { required: true, message: '请输入链接地址', trigger: 'blur' },
                    {
                        validator(rule, value, callback) {
                            if (/^(https?:\/\/|tg:\/\/).+/.test(value)) {
                                callback(); // 合法链接：http://、https:// 或 tg:// 开头
                            } else {
                                callback(new Error('链接地址必须以 http://、https:// 或 tg:// 开头'));
                            }
                        },
                        trigger: 'blur'
                    }
                ]
            },
            activeTab: 'query',
            setting: {
                enabled: true,
                interval: 5,
                mode: 'send_and_pin',
                cancelLastPin: false,
                deleteLastAd: false
            },
            jsonInput: '',
            previewCount: 0,
            isFormatted: false,

            currentBtnListType: 'success', // 当前操作的按钮列表类型：只有 'success'
            // 骰子游戏用户参与详情弹窗相关数据
            detailDialogVisible: false,
            diceuserHisData: [],
            diceuserHisLoading: false,
            diceuserHisCurrentPage: 1,
            diceuserHisPageSize: 10,
            diceuserHisTotal: 0,
            currentqiNum: null,
            currentGroupId: null
        }
    },
    computed: {
        vuexUser() {
            return this.$store.state.user;
        }
    },
    watch: {
        vuexUser: {
            handler(newUser) {
                if (newUser) {
                    this.loadUserInfo(newUser);
                }
            },
            deep: true,
            immediate: true
        },
        jsonInput: {
            handler(newValue) {
                if (newValue && newValue.trim()) {
                    this.processJsonInput(newValue);
                } else {
                    this.previewCount = 0;
                }
            },
            immediate: false
        }
    },
    methods: {



        handleTabClick(tab) {
            // console.log('标签点击:', JSON.stringify(tab));
            if (tab.paneName == 'query') {
                this.initRichTextEditor();
                this.fetchSetting()
            } else if (tab.paneName == 'rank') {
                this.initRichTextEditor();
                this.fetchSetting()
            } else if (tab.paneName == 'flow') {
                this.initRichTextEditor();
                this.fetchSetting()
            }
        },

        fetchSetting() {
            // return;
            /////////调用group表的对应api接口获取群的配置
            api.getGroupById(this.currentUserInfo.groupId).then(res => {
                if (res.data.ReplyPointsconfig && res.data.ReplyPointsconfig != null && res.data.ReplyPointsconfig != '') {
                    this.ReplyPointsconfig = res.data.ReplyPointsconfig;
                }
            }).catch(error => {
                this.$message.error('获取骰子游戏配置失败: ' + (error.response?.data?.message || error.message || '网络错误'));
            });
        },





        // 处理关键词标签关闭 - 通用方法
        handleKeywordTagClose(tag, listType) {
            const index = this.ReplyPointsconfig[listType].indexOf(tag);
            if (index > -1) {
                this.ReplyPointsconfig[listType].splice(index, 1);
            }
        },

        // 处理关键词输入确认 - 通用方法
        handleKeywordInputConfirm(listType) {
            const inputValue = this.keyword_input.trim();
            if (inputValue && !this.ReplyPointsconfig[listType].includes(inputValue)) {
                this.ReplyPointsconfig[listType].push(inputValue);
            }
            this.keyword_input = '';
        },

        saveSetting() {


            api.updateReplyPointsConfig(this.currentUserInfo.groupId, {
                ReplyPointsconfig: this.ReplyPointsconfig
            }).then(res => {
                if (res.data.code == 0) {
                    this.$message.success('积分回复配置保存成功');
                    this.fetchSetting();
                } else {
                    this.$message.error(res.data.message || '保存失败');
                }
            }).catch(error => {
                this.$message.error('保存失败: ' + (error.response?.data?.message || error.message || '网络错误'));
            });
        },



        loadUserInfo(user) {
            this.currentUserInfo.userId = user.userId;
            this.currentUserInfo.groupId = user.groupId;
            this.currentUserInfo.userBot = user.userBot;
        },














        removeButton(rowIndex, btnIndex, btnListType = 'success') {
            // 根据当前标签页确定要操作的按钮列表
            let btnList;
            if (this.activeTab === 'query') {
                btnList = this.ReplyPointsconfig.pointMsgBtnList;
            } else if (this.activeTab === 'rank') {
                btnList = this.ReplyPointsconfig.msgBtnList;
            } else if (this.activeTab === 'flow') {
                btnList = this.ReplyPointsconfig.logMsgBtnList;
            }

            btnList[rowIndex].splice(btnIndex, 1);
            // 如果删除按钮后该行没有按钮了，则删除整行
            if (btnList[rowIndex].length === 0) {
                btnList.splice(rowIndex, 1);

                // 如果当前选中的行被删除了，重置状态
                if (this.currentRowIndex === rowIndex) {
                    this.currentRowIndex = -1;
                }
                // 如果删除的行在当前选中行之前，需要调整索引
                else if (this.currentRowIndex > rowIndex) {
                    this.currentRowIndex--;
                }
            }
        },
        addButton(rowIndex, btnListType = 'success') {
            // 根据当前标签页确定要操作的按钮列表
            let btnList;
            if (this.activeTab === 'query') {
                btnList = this.ReplyPointsconfig.pointMsgBtnList;
            } else if (this.activeTab === 'rank') {
                btnList = this.ReplyPointsconfig.msgBtnList;
            } else if (this.activeTab === 'flow') {
                btnList = this.ReplyPointsconfig.logMsgBtnList;
            }
            btnList[rowIndex].push({ text: '', url: '' });
        },
        editButton(rowIndex, btnIndex, btnListType = 'success') {
            // 设置编辑状态
            this.editingButtonRowIndex = rowIndex;
            this.editingButtonIndex = btnIndex;
            this.currentRowIndex = rowIndex;
            this.currentBtnListType = btnListType;

            // 根据当前标签页确定要操作的按钮列表
            let btnList;
            if (this.activeTab === 'query') {
                btnList = this.ReplyPointsconfig.pointMsgBtnList;
            } else if (this.activeTab === 'rank') {
                btnList = this.ReplyPointsconfig.msgBtnList;
            } else if (this.activeTab === 'flow') {
                btnList = this.ReplyPointsconfig.logMsgBtnList;
            }

            // 填充表单数据
            const button = btnList[rowIndex][btnIndex];
            this.buttonForm.text = button.text;
            this.buttonForm.url = button.url;

            // 显示对话框
            this.buttonDialogVisible = true;
        },


        formatText(type) {
            const textarea = this.$refs.replaytextInput.$refs.textarea;
            if (!textarea) return;

            const start = textarea.selectionStart;
            const end = textarea.selectionEnd;
            const selectedText = this.form.msgContent.msgText.substring(start, end);
            let replacement = selectedText;
            let preSelection = 0;
            let postSelection = 0;

            switch (type) {
                case 'bold':
                    replacement = `**${selectedText}**`;
                    preSelection = 2;
                    postSelection = 2;
                    break;
                case 'italic':
                    replacement = `_${selectedText}_`;
                    preSelection = 1;
                    postSelection = 1;
                    break;
                case 'strikethrough':
                    replacement = `~${selectedText}~`;
                    preSelection = 1;
                    postSelection = 1;
                    break;
                case 'code':
                    replacement = `\`${selectedText}\``;
                    preSelection = 1;
                    postSelection = 1;
                    break;
                case 'link':
                    {
                        const url = prompt("请输入链接 URL:", "https://");
                        if (url) {
                            replacement = `[${selectedText}](${url})`;
                            preSelection = 1;
                            postSelection = url.length + 3 + (selectedText.length > 0 ? 0 : -selectedText.length);
                        } else {
                            return;
                        }
                        break;
                    }
            }

            this.form.msgContent.msgText = this.form.msgContent.msgText.substring(0, start) + replacement + this.form.msgContent.msgText.substring(end);

            this.$nextTick(() => {
                textarea.focus();
                if (selectedText.length === 0) {
                    const newCursorPos = start + preSelection;
                    textarea.setSelectionRange(newCursorPos, newCursorPos);
                } else {
                    const newStart = start + preSelection;
                    const newEnd = start + replacement.length - postSelection;
                    textarea.setSelectionRange(newStart, newEnd);
                }
            });
        },
        insertHtml(tag, closeTag) {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        toggleMode() {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        handleVisualInput(event) {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        handleCompositionStart() {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        handleCompositionEnd(event) {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        handlePaste() {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        handleKeydown() {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        setVisualEditorContent(content) {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        // 保存光标位置
        saveCaretPosition() {
            const selection = window.getSelection();
            if (selection.rangeCount > 0) {
                const range = selection.getRangeAt(0);
                const preCaretRange = range.cloneRange();
                preCaretRange.selectNodeContents(this.$refs.visualEditor);
                preCaretRange.setEnd(range.endContainer, range.endOffset);
                return preCaretRange.toString().length;
            }
            return 0;
        },

        // 恢复光标位置
        restoreCaretPosition(caretPos) {
            const editor = this.$refs.visualEditor;
            if (!editor) return;

            const selection = window.getSelection();
            const range = document.createRange();

            let charIndex = 0;
            let nodeStack = [editor];
            let node, foundStart = false;

            while (!foundStart && (node = nodeStack.pop())) {
                if (node.nodeType === Node.TEXT_NODE) {
                    const nextCharIndex = charIndex + node.textContent.length;
                    if (caretPos >= charIndex && caretPos <= nextCharIndex) {
                        range.setStart(node, caretPos - charIndex);
                        range.setEnd(node, caretPos - charIndex);
                        foundStart = true;
                    }
                    charIndex = nextCharIndex;
                } else {
                    let i = node.childNodes.length;
                    while (i--) {
                        nodeStack.push(node.childNodes[i]);
                    }
                }
            }

            if (foundStart) {
                selection.removeAllRanges();
                selection.addRange(range);
            }
        },
        handleVisualInputMyLink(event) {
            const content = event.target.innerHTML;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(() => {
                if (content !== this.ReplyPointsconfig.pointHtml) {
                    this.ReplyPointsconfig.pointHtml = content;
                }
            }, 300);
        },
        handleCompositionStartMyLink() {
            this.isComposing = true;
        },
        handleCompositionEndMyLink(event) {
            this.isComposing = false;
            const content = event.target.innerHTML;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            if (content !== this.ReplyPointsconfig.pointHtml) {
                this.ReplyPointsconfig.pointHtml = content;
            }
        },
        handlePasteMyLink() {
            // 让浏览器处理粘贴
        },
        handleKeydownMyLink() {
            // 让浏览器处理按键
        },
        setVisualEditorContentMyLink(content) {
            if (this.$refs.visualEditorMyLink && !this.isSourceModeMyLink) {
                this.$refs.visualEditorMyLink.innerHTML = content || '';
            }
        },

        // 第二个富文本编辑器的方法（积分排行回复内容）
        insertHtmlSuccess(tag, closeTag) {
            if (this.isSourceModeSuccess) {
                const textarea = this.$refs.htmlTextareaSuccess.$refs.textarea;
                if (!textarea) return;

                const start = textarea.selectionStart;
                const end = textarea.selectionEnd;
                const selectedText = this.ReplyPointsconfig.msgContent.substring(start, end);
                let replacement = selectedText;
                let preSelection = 0;
                let postSelection = 0;

                if (selectedText.length > 0) {
                    replacement = tag + selectedText + (closeTag || '');
                    preSelection = tag.length;
                    postSelection = (closeTag || '').length;
                } else {
                    replacement = tag + (closeTag || '');
                    preSelection = tag.length;
                }

                this.ReplyPointsconfig.msgContent = this.ReplyPointsconfig.msgContent.substring(0, start) + replacement + this.ReplyPointsconfig.msgContent.substring(end);

                this.$nextTick(() => {
                    textarea.focus();
                    if (selectedText.length === 0) {
                        const newCursorPos = start + preSelection;
                        textarea.setSelectionRange(newCursorPos, newCursorPos);
                    } else {
                        const newStart = start + preSelection;
                        const newEnd = start + replacement.length - postSelection;
                        textarea.setSelectionRange(newStart, newEnd);
                    }
                });
            } else {
                const visualEditor = this.$refs.visualEditorSuccess;
                if (!visualEditor) return;

                visualEditor.focus();

                if (tag === '<br>') {
                    document.execCommand('insertHTML', false, '<br>');
                } else if (tag === '<b>') {
                    document.execCommand('bold', false, null);
                } else if (tag === '<i>') {
                    document.execCommand('italic', false, null);
                } else if (tag === '<u>') {
                    document.execCommand('underline', false, null);
                } else if (tag === '<h1>') {
                    document.execCommand('formatBlock', false, 'h1');
                } else if (tag === '<h2>') {
                    document.execCommand('formatBlock', false, 'h2');
                } else if (tag === '<ul><li>') {
                    document.execCommand('insertUnorderedList', false, null);
                } else if (tag === '<ol><li>') {
                    document.execCommand('insertOrderedList', false, null);
                }

                this.ReplyPointsconfig.msgContent = visualEditor.innerHTML;
            }
        },
        toggleModeSuccess() {
            this.isSourceModeSuccess = !this.isSourceModeSuccess;
            if (!this.isSourceModeSuccess) {
                this.$nextTick(() => {
                    this.setVisualEditorContentSuccess(this.ReplyPointsconfig.msgContent);
                });
            }
        },
        handleVisualInputSuccess(event) {
            const content = event.target.innerHTML;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(() => {
                if (content !== this.ReplyPointsconfig.msgContent) {
                    this.ReplyPointsconfig.msgContent = content;
                }
            }, 300);
        },
        handleCompositionStartSuccess() {
            this.isComposing = true;
        },
        handleCompositionEndSuccess(event) {
            this.isComposing = false;
            const content = event.target.innerHTML;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            if (content !== this.ReplyPointsconfig.msgContent) {
                this.ReplyPointsconfig.msgContent = content;
            }
        },
        handlePasteSuccess() {
            // 让浏览器处理粘贴
        },
        handleKeydownSuccess() {
            // 让浏览器处理按键
        },
        setVisualEditorContentSuccess(content) {
            if (this.$refs.visualEditorSuccess && !this.isSourceModeSuccess) {
                this.$refs.visualEditorSuccess.innerHTML = content || '';
            }
        },

        // 第三个富文本编辑器的方法（积分流水回复内容）
        insertHtmlLog(tag, closeTag) {
            if (this.isSourceModeLog) {
                const textarea = this.$refs.htmlTextareaLog.$refs.textarea;
                if (!textarea) return;

                const start = textarea.selectionStart;
                const end = textarea.selectionEnd;
                const selectedText = this.ReplyPointsconfig.logHtml.substring(start, end);
                let replacement = selectedText;
                let preSelection = 0;
                let postSelection = 0;

                if (selectedText.length > 0) {
                    replacement = tag + selectedText + (closeTag || '');
                    preSelection = tag.length;
                    postSelection = (closeTag || '').length;
                } else {
                    replacement = tag + (closeTag || '');
                    preSelection = tag.length;
                }

                this.ReplyPointsconfig.logHtml = this.ReplyPointsconfig.logHtml.substring(0, start) + replacement + this.ReplyPointsconfig.logHtml.substring(end);

                this.$nextTick(() => {
                    textarea.focus();
                    if (selectedText.length === 0) {
                        const newCursorPos = start + preSelection;
                        textarea.setSelectionRange(newCursorPos, newCursorPos);
                    } else {
                        const newStart = start + preSelection;
                        const newEnd = start + replacement.length - postSelection;
                        textarea.setSelectionRange(newStart, newEnd);
                    }
                });
            } else {
                const visualEditor = this.$refs.visualEditorLog;
                if (!visualEditor) return;

                visualEditor.focus();

                if (tag === '<br>') {
                    document.execCommand('insertHTML', false, '<br>');
                } else if (tag === '<b>') {
                    document.execCommand('bold', false, null);
                } else if (tag === '<i>') {
                    document.execCommand('italic', false, null);
                } else if (tag === '<u>') {
                    document.execCommand('underline', false, null);
                } else if (tag === '<h1>') {
                    document.execCommand('formatBlock', false, 'h1');
                } else if (tag === '<h2>') {
                    document.execCommand('formatBlock', false, 'h2');
                } else if (tag === '<ul><li>') {
                    document.execCommand('insertUnorderedList', false, null);
                } else if (tag === '<ol><li>') {
                    document.execCommand('insertOrderedList', false, null);
                }

                this.ReplyPointsconfig.logHtml = visualEditor.innerHTML;
            }
        },
        toggleModeLog() {
            this.isSourceModeLog = !this.isSourceModeLog;
            if (!this.isSourceModeLog) {
                this.$nextTick(() => {
                    this.setVisualEditorContentLog(this.ReplyPointsconfig.logHtml);
                });
            }
        },
        handleVisualInputLog(event) {
            const content = event.target.innerHTML;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(() => {
                if (content !== this.ReplyPointsconfig.logHtml) {
                    this.ReplyPointsconfig.logHtml = content;
                }
            }, 300);
        },
        handleCompositionStartLog() {
            this.isComposing = true;
        },
        handleCompositionEndLog(event) {
            this.isComposing = false;
            const content = event.target.innerHTML;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            if (content !== this.ReplyPointsconfig.logHtml) {
                this.ReplyPointsconfig.logHtml = content;
            }
        },
        handlePasteLog() {
            // 让浏览器处理粘贴
        },
        handleKeydownLog() {
            // 让浏览器处理按键
        },
        setVisualEditorContentLog(content) {
            if (this.$refs.visualEditorLog && !this.isSourceModeLog) {
                this.$refs.visualEditorLog.innerHTML = content || '';
            }
        },

        // 显示添加按钮对话框
        showAddButtonDialog(rowIndex, btnListType = 'success') {
            // 根据当前标签页确定要操作的按钮列表
            let btnList;
            if (this.activeTab === 'query') {
                btnList = this.ReplyPointsconfig.pointMsgBtnList;
            } else if (this.activeTab === 'rank') {
                btnList = this.ReplyPointsconfig.msgBtnList;
            } else if (this.activeTab === 'flow') {
                btnList = this.ReplyPointsconfig.logMsgBtnList;
            }

            // 检查是否超过每行最大按钮数限制
            if (rowIndex !== -1 && btnList[rowIndex] && btnList[rowIndex].length >= 5) {
                this.$message.warning('每一行最多允许5个按钮');
                return;
            }

            // 重置编辑状态
            this.editingButtonRowIndex = -1;
            this.editingButtonIndex = -1;
            this.currentBtnListType = btnListType;

            this.currentRowIndex = rowIndex;
            this.buttonForm = {
                text: '',
                url: ''
            };
            this.buttonDialogVisible = true;
        },
        // 获取对话框标题
        getDialogTitle() {
            // 根据当前标签页确定要操作的按钮列表和名称
            let btnList, listName;
            if (this.activeTab === 'query') {
                btnList = this.ReplyPointsconfig.pointMsgBtnList;
                listName = '积分查询';
            } else if (this.activeTab === 'rank') {
                btnList = this.ReplyPointsconfig.msgBtnList;
                listName = '积分排行';
            } else if (this.activeTab === 'flow') {
                btnList = this.ReplyPointsconfig.logMsgBtnList;
                listName = '积分流水';
            }

            if (this.editingButtonIndex !== -1) {
                // 编辑模式
                const rowNum = this.editingButtonRowIndex + 1;
                const btnNum = this.editingButtonIndex + 1;
                return `编辑${listName}第${rowNum}行第${btnNum}个按钮`;
            } else if (this.currentRowIndex === -1) {
                return `新增${listName}一行按钮`;
            } else {
                // 检查行是否存在，防止访问已删除的行
                if (btnList[this.currentRowIndex]) {
                    const rowNum = this.currentRowIndex + 1;
                    const btnNum = btnList[this.currentRowIndex].length + 1;
                    return `${listName}第${rowNum}行第${btnNum}个按钮`;
                } else {
                    return `新增${listName}一行按钮`;
                }
            }
        },
        // 确认添加按钮
        confirmAddButton() {
            // 验证表单
            this.$refs.buttonFormRef.validate((valid) => {
                if (!valid) {
                    return;
                }

                const buttonData = {
                    text: this.buttonForm.text.trim(),
                    url: this.buttonForm.url.trim()
                };

                // 根据当前标签页确定要操作的按钮列表
                let btnList;
                if (this.activeTab === 'query') {
                    btnList = this.ReplyPointsconfig.pointMsgBtnList;
                } else if (this.activeTab === 'rank') {
                    btnList = this.ReplyPointsconfig.msgBtnList;
                } else if (this.activeTab === 'flow') {
                    btnList = this.ReplyPointsconfig.logMsgBtnList;
                }

                if (this.editingButtonIndex !== -1) {
                    // 编辑模式：更新现有按钮
                    btnList[this.editingButtonRowIndex][this.editingButtonIndex] = buttonData;
                    this.$message.success('按钮编辑成功');

                    // 重置编辑状态
                    this.editingButtonRowIndex = -1;
                    this.editingButtonIndex = -1;
                } else if (this.currentRowIndex === -1) {
                    // 新增一行按钮
                    btnList.push([buttonData]);
                    this.$message.success('按钮添加成功');
                } else {
                    // 在指定行添加按钮 - 检查行是否存在
                    if (btnList[this.currentRowIndex]) {
                        btnList[this.currentRowIndex].push(buttonData);
                        this.$message.success('按钮添加成功');
                    } else {
                        // 如果指定行不存在，创建新行
                        btnList.push([buttonData]);
                        this.$message.success('按钮添加成功');
                    }
                }

                this.buttonDialogVisible = false;
            });
        },

        // 拖拽相关方法
        handleDragStart(rowIndex) {
            this.draggedRowIndex = rowIndex;
        },

        handleDragEnd() {
            this.draggedRowIndex = null;
        },

        handleDragOver(event) {
            event.preventDefault();
        },

        handleDrop(event, targetRowIndex, btnListType = 'success') {
            event.preventDefault();
            event.stopPropagation();

            if (this.draggedRowIndex === null || this.draggedRowIndex === targetRowIndex) {
                return;
            }

            const fromIndex = this.draggedRowIndex;
            const toIndex = targetRowIndex;

            // 根据当前标签页确定要操作的按钮列表
            let btnList;
            if (this.activeTab === 'query') {
                btnList = this.ReplyPointsconfig.pointMsgBtnList;
            } else if (this.activeTab === 'rank') {
                btnList = this.ReplyPointsconfig.msgBtnList;
            } else if (this.activeTab === 'flow') {
                btnList = this.ReplyPointsconfig.logMsgBtnList;
            }

            // 移动按钮行 - 创建新数组强制响应式更新
            const newButtons = [...btnList];
            const draggedRow = newButtons[fromIndex];

            // 移除原位置的行
            newButtons.splice(fromIndex, 1);
            // 插入到新位置
            newButtons.splice(toIndex, 0, draggedRow);

            // 替换整个数组触发响应式更新
            if (this.activeTab === 'query') {
                this.ReplyPointsconfig.pointMsgBtnList = newButtons;
            } else if (this.activeTab === 'rank') {
                this.ReplyPointsconfig.msgBtnList = newButtons;
            } else if (this.activeTab === 'flow') {
                this.ReplyPointsconfig.logMsgBtnList = newButtons;
            }

            // 强制Vue重新渲染
            this.$nextTick(() => {
                this.$forceUpdate();
            });

            this.$message.success(`第${fromIndex + 1}行已移动到第${toIndex + 1}行`);
        },

        // 解析按钮文本数据为二维数组
        parseButtonData(buttonText) {
            if (!buttonText || typeof buttonText !== 'string') {
                return [];
            }

            try {
                // 1. 按换行符分割成行
                const lines = buttonText.split('\n').filter(line => line.trim());

                // 2. 每行按分号分割成按钮
                const buttons = lines.map(line => {
                    return line.split(';').filter(item => item.trim()).map(item => {
                        // 3. 解析每个按钮的文字和链接 格式: 文字(链接)
                        const match = item.trim().match(/^(.+?)\((.+?)\)$/);
                        if (match) {
                            return {
                                text: match[1].trim(),
                                url: match[2].trim()
                            };
                        }
                        return null;
                    }).filter(Boolean);
                }).filter(row => row.length > 0);

                return buttons;
            } catch (error) {
                console.error('解析按钮数据失败:', error);
                return [];
            }
        },


        // 初始化富文本编辑器
        initRichTextEditor() {
            this.$nextTick(() => {
                // 初始化第一个富文本编辑器（积分查询回复内容）
                if (this.$refs.visualEditorMyLink && !this.isSourceModeMyLink) {
                    this.$refs.visualEditorMyLink.innerHTML = this.ReplyPointsconfig.pointHtml || '';
                }

                // 初始化第二个富文本编辑器（积分排行回复内容）
                if (this.$refs.visualEditorSuccess && !this.isSourceModeSuccess) {
                    this.$refs.visualEditorSuccess.innerHTML = this.ReplyPointsconfig.msgContent || '';
                }

                // 初始化第三个富文本编辑器（积分流水回复内容）
                if (this.$refs.visualEditorLog && !this.isSourceModeLog) {
                    this.$refs.visualEditorLog.innerHTML = this.ReplyPointsconfig.logHtml || '';
                }
            });
        },
        removeButtonRow(rowIndex, btnListType = 'success') {
            // 根据当前标签页确定要操作的按钮列表
            let btnList;
            if (this.activeTab === 'query') {
                btnList = this.ReplyPointsconfig.pointMsgBtnList;
            } else if (this.activeTab === 'rank') {
                btnList = this.ReplyPointsconfig.msgBtnList;
            } else if (this.activeTab === 'flow') {
                btnList = this.ReplyPointsconfig.logMsgBtnList;
            }
            btnList.splice(rowIndex, 1);
        },



    },
    mounted() {
        if (this.$store.state.user) {
            this.loadUserInfo(this.$store.state.user);
            this.fetchSetting()
        }
        this.initRichTextEditor();
    }
}
</script>

<style scoped>
.auto-reply {
    padding: 20px;
}

.search-section {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.button-group {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.stats-section {
    margin-bottom: 20px;
}

.stats-card {
    text-align: center;
}

.stats-item {
    padding: 10px;
}

.stats-value {
    font-size: 24px;
    font-weight: bold;
    color: #409eff;
    margin-bottom: 5px;
}

.stats-label {
    font-size: 14px;
    color: #666;
}

.keyword-display {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.keyword-desc {
    margin-top: 5px;
}

.reply-content {
    max-width: 300px;
    word-break: break-all;
}

.media-url {
    margin-top: 5px;
    padding: 5px;
    background: #f5f5f5;
    border-radius: 4px;
}

.advanced-settings {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.pagination {
    margin-top: 20px;
    text-align: center;
}

.dialog-footer {
    text-align: right;
}

.upload-demo {
    text-align: center;
}

.el-upload__tip {
    color: #666;
    font-size: 12px;
    margin-top: 10px;
}

.placeholder-description {
    font-size: 12px;
    color: #999;
    margin-top: 10px;
    line-height: 1.5;
}

.button-input-area {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 10px;
    min-height: 60px;
    margin-bottom: 10px;
}

.button-row {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.button-item {
    display: flex;
    align-items: center;
    gap: 5px;
}

.button-controls {
    display: flex;
    gap: 10px;
}

.delete-row-btn {
    background-color: #fee;
    color: #f56c6c;
    border-color: #fde2e2;
}

.delete-row-btn:hover {
    background-color: #fdd;
    color: #f23c3c;
}

.other-settings {
    margin-top: 15px;
}

.setting-label {
    color: var(--el-text-color-regular);
    margin-right: 12px;
}

.form-label-with-icon {
    display: flex;
    align-items: center;
    gap: 4px;
}

.required-asterisk {
    color: var(--el-color-danger);
    margin-right: 4px;
}

.condition-input-group {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 10px;
}

.reply-content-head {
    display: flex;
    align-items: flex-start;
}

.keyword-tags-input {
    flex-grow: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 5px;
    border: 1px solid var(--el-border-color);
    border-radius: 4px;
    padding: 2px 8px;
    min-height: 32px;
    max-width: 350px;
}

.keyword-new-tag-input {
    border: none;
    outline: none;
    flex-grow: 1;
    min-width: 80px;
    background-color: transparent;
}

.html-editor {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: white;
    max-width: 460px;
}

.html-textarea {
    width: 100%;
    max-width: 460px;
}

.html-textarea :deep(.el-textarea__inner) {
    max-height: 200px;
    min-height: 120px;
    resize: vertical;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.html-toolbar {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border-bottom: 1px solid #dcdfe6;
    background: #f5f7fa;
    flex-wrap: wrap;
    gap: 4px;
}

.html-toolbar button {
    padding: 4px 8px;
    border: 1px solid #dcdfe6;
    background: white;
    border-radius: 3px;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.2s;
    min-width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.html-toolbar button:hover:not(:disabled) {
    background: #ecf5ff;
    border-color: #409eff;
}

.html-toolbar button.is-active {
    background: #409eff;
    color: white;
    border-color: #409eff;
}

.html-toolbar button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #f5f7fa;
}

.html-toolbar .divider {
    margin: 0 8px;
    color: #dcdfe6;
}

.editor-content-area {
    border: 1px solid #dcdfe6;
    border-top: none;
    border-radius: 0 0 4px 4px;
}

.visual-editor {
    min-height: 50px;
    max-height: 200px;
    height: 200px;
    padding: 12px;
    outline: none;
    cursor: text;
    line-height: 1.6;
    font-size: 14px;
    background: white;
    border-radius: 0 0 4px 4px;
    direction: ltr;
    text-align: left;
    unicode-bidi: normal;
    overflow-y: auto;
    word-wrap: break-word;
    overflow-wrap: break-word;
    box-sizing: border-box;
}

.visual-editor:focus {
    outline: none;
}

.visual-editor p {
    margin: 8px 0;
}

.visual-editor p:first-child {
    margin-top: 0;
}

.visual-editor p:last-child {
    margin-bottom: 0;
}

.visual-editor h1,
.visual-editor h2,
.visual-editor h3 {
    margin: 16px 0 8px 0;
    font-weight: bold;
}

.visual-editor h1 {
    font-size: 1.5em;
}

.visual-editor h2 {
    font-size: 1.3em;
}

.visual-editor ul,
.visual-editor ol {
    padding-left: 20px;
    margin: 8px 0;
}

.visual-editor li {
    margin: 4px 0;
}

.visual-editor strong,
.visual-editor b {
    font-weight: bold;
}

.visual-editor em,
.visual-editor i {
    font-style: italic;
}

.visual-editor u {
    text-decoration: underline;
}

.visual-editor[contenteditable]:empty:before {
    content: "请输入回复内容...";
    color: #c0c4cc;
    font-style: italic;
}

.reply-type-horizontal {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: nowrap;
}

.type-select-container {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    min-width: 250px;
}

.media-url-container {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    min-width: 350px;
    padding: 4px 8px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border-left: 3px solid #409eff;
    animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
    from {
        opacity: 0;
        transform: translateX(20px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.reply-type-dropdown {
    max-height: 200px;
    overflow-y: auto;
    z-index: 9999;
}

/* 按钮行列表样式 */
.button-rows-list {
    margin-bottom: 2px;
}

.button-row-wrapper {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 2px;
    margin-left: 35px;
    /* 与新增一行按钮对齐 */
    border-radius: 6px;
    padding: 6px;
    transition: all 0.3s ease;
}

.button-row-wrapper.drag-over {
    background-color: #f0f9ff;
    border: 2px dashed #1890ff;
    transform: scale(1.02);
}

.gray-buttons-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
    /* 不允许换行 */
    width: 480px;
    /* 与新增一行按钮宽度一致 */
    flex-shrink: 0;
    /* 不允许收缩 */
}

.button-item {
    background: #a8a8a8;
    color: white;
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 14px;
    text-align: center;
    border: none;
    cursor: default;
    white-space: nowrap;
    /* 文字不换行 */
    flex: 1;
    /* 弹性宽度，平均分配空间 */
    min-width: 0;
    /* 允许收缩到内容宽度 */
    overflow: hidden;
    /* 防止内容溢出 */
    text-overflow: ellipsis;
    /* 文字过长时显示省略号 */
    position: relative;
    /* 为操作按钮定位提供参考 */
    transition: all 0.3s ease;
    height: 36px;
    /* 确保与蓝色按钮高度一致 */
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

.button-item:hover {
    background: #909399;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.button-actions {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    display: flex;
    gap: 4px;
    opacity: 0;
    transition: opacity 0.2s ease;
    z-index: 2;
}

.button-item:hover .button-actions {
    opacity: 1;
}

.button-action-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
}

.edit-icon {
    background: #409eff;
}

.edit-icon:hover {
    background: #66b1ff;
    transform: scale(1.1);
}

.delete-icon {
    background: #f56c6c;
}

.delete-icon:hover {
    background: #f78989;
    transform: scale(1.1);
}

.button-action-icon .el-icon {
    font-size: 12px;
    color: white;
}

.add-button-container {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.add-to-row-button {
    background: #1890ff;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;
    transition: background-color 0.3s ease;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

.add-to-row-button:hover {
    background: #40a9ff;
}

/* 新增按钮样式 */
.button-controls {
    display: flex;
    align-items: center;
    padding: 0;
}

.add-row-button {
    border: 1px dashed #d9d9d9;
    background: #fff;
    color: #666;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s;
    outline: none;
    min-width: 480px;
    height: 36px;
    margin-left: 35px;
}

.add-row-button:hover {
    border-color: #1890ff;
    color: #1890ff;
}

.drag-icon-container {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    cursor: grab;
    user-select: none;
}

.drag-icon-container:active {
    cursor: grabbing;
}

.drag-icon {
    font-size: 16px;
    color: #8c8c8c;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.3s ease;
}

.drag-icon-container:hover .drag-icon {
    color: #1890ff;
}

.drag-icon-container[draggable="true"] {
    cursor: grab;
}

.drag-icon-container[draggable="true"]:active {
    cursor: grabbing;
}

/* 变量说明样式 */
.variable-help-text {
    margin-top: -10px;
    margin-bottom: 20px;
    margin-left: 120px;
    max-width: 430px;
    /* 与表单标签对齐 */
    padding: 12px 16px;
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    font-size: 13px;
    line-height: 1.6;
    color: #6c757d;
}

.variable-item {
    display: inline;
}

.variable-help-text code {
    background-color: #e3f2fd;
    color: #1976d2;
    padding: 2px 6px;
    border-radius: 3px;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 12px;
    font-weight: 600;
    border: 1px solid #bbdefb;
}

.carousel-tabs .el-tabs__item {
    font-size: 18px;
    font-weight: bold;
    padding: 16px 40px 12px 40px;
}

.carousel-banner {
    background: linear-gradient(90deg, #6a82fb 0%, #fc5c7d 100%);
    color: #fff;
    border-radius: 18px 18px 0 0;
    padding: 36px 36px 18px 36px;
    text-align: left;
    margin-bottom: -18px;
    box-shadow: 0 4px 24px rgba(100, 100, 100, 0.10);
}

.carousel-banner-title {
    font-size: 2.2rem;
    font-weight: bold;
    letter-spacing: 2px;
}

.carousel-banner-desc {
    font-size: 1.1rem;
    opacity: 0.90;
    margin-top: 10px;
}

.carousel-setting-card {
    border-radius: 18px;
    box-shadow: 0 2px 18px rgba(100, 100, 100, 0.10);
    padding: 38px 28px 28px 28px;
    margin-top: 0;
}

.form-section-title {
    font-size: 1.15rem;
    font-weight: 600;
    margin: 28px 0 10px 0;
    color: #6a82fb;
    letter-spacing: 1px;
}

.big-switch :deep(.el-switch__core) {
    width: 56px !important;
    height: 28px !important;
    border-radius: 18px !important;
}

.big-switch :deep(.el-switch__action) {
    width: 28px !important;
    height: 28px !important;
}

.big-submit-btn {
    width: 280px;
    background: linear-gradient(90deg, #6a82fb 0%, #fc5c7d 100%);
    border: none;
    border-radius: 10px;
    font-size: 1.15rem;
    font-weight: bold;
    box-shadow: 0 2px 8px rgba(252, 92, 125, 0.12);
    padding: 14px 0;
    margin-top: 18px;
}

/* 拖拽上传样式 */
.json-upload-drag {
    width: 100%;
}

.json-upload-drag :deep(.el-upload-dragger) {
    width: 100%;
    height: 120px;
    border: 2px dashed #d9d9d9;
    border-radius: 8px;
    background: #fafafa;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.json-upload-drag :deep(.el-upload-dragger:hover) {
    border-color: #409eff;
    background: #f0f9ff;
}

.json-upload-drag :deep(.el-upload-dragger.is-dragover) {
    border-color: #409eff;
    background: #e6f7ff;
    transform: scale(1.02);
}

.json-upload-drag :deep(.el-icon--upload) {
    font-size: 28px;
    color: #c0c4cc;
    margin-bottom: 8px;
    transition: color 0.3s ease;
}

.json-upload-drag :deep(.el-upload-dragger:hover .el-icon--upload) {
    color: #409eff;
}

.json-upload-drag :deep(.el-upload__text) {
    color: #606266;
    font-size: 14px;
    text-align: center;
    line-height: 1.5;
}

.json-upload-drag :deep(.el-upload__text em) {
    color: #409eff;
    font-style: normal;
    font-weight: bold;
}

.json-upload-drag :deep(.el-upload__tip) {
    color: #888;
    font-size: 12px;
    line-height: 1.6;
    margin-top: 8px;
    text-align: center;
}

.media-group-manager {
    display: flex;
    flex-direction: column;
    gap: 15px;
    min-height: 200px;
}

.media-item {
    padding: 15px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
}

.media-item-content {
    display: flex;
    align-items: center;
    gap: 12px;
}

.media-index {
    font-weight: bold;
    color: #409eff;
    min-width: 30px;
}

.add-media-section {
    display: flex;
    justify-content: center;
    padding: 20px;
    border: 2px dashed #d9d9d9;
    border-radius: 8px;
    background: #fafafa;
}

.add-media-section:hover {
    border-color: #409eff;
    background: #f0f9ff;
}

.media-management-container {
    display: flex;
    align-items: center;
    margin-top: 10px;
}

/* 3D骰子样式 */
.dice-container {
    display: flex;
    align-items: center;
    gap: 12px;
}

.dice {
    width: 40px;
    height: 40px;
    background: linear-gradient(145deg, #ffffff, #e6e6e6);
    border: 2px solid #d0d0d0;
    border-radius: 8px;
    box-shadow:
        0 4px 8px rgba(0, 0, 0, 0.1),
        inset 0 1px 0 rgba(255, 255, 255, 0.8),
        inset 0 -1px 0 rgba(0, 0, 0, 0.1);
    position: relative;
    transform: rotateX(15deg) rotateY(15deg);
    transition: all 0.3s ease;
    cursor: pointer;
}

.dice:hover {
    transform: rotateX(20deg) rotateY(20deg) scale(1.1);
    box-shadow:
        0 8px 16px rgba(0, 0, 0, 0.15),
        inset 0 1px 0 rgba(255, 255, 255, 0.9),
        inset 0 -1px 0 rgba(0, 0, 0, 0.15);
}

.dice-inner {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.dice-dots {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 2px;
    width: 100%;
    height: 100%;
    padding: 4px;
}

.dot {
    width: 6px;
    height: 6px;
    background: #333;
    border-radius: 50%;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* 骰子点数布局 */
.dice-1 .dice-dots {
    grid-template-areas:
        ". . ."
        ". center ."
        ". . .";
}

.dice-1 .dot:nth-child(1) {
    grid-area: center;
}

.dice-2 .dice-dots {
    grid-template-areas:
        "top-left . ."
        ". . ."
        ". . bottom-right";
}

.dice-2 .dot:nth-child(1) {
    grid-area: top-left;
}

.dice-2 .dot:nth-child(2) {
    grid-area: bottom-right;
}

.dice-3 .dice-dots {
    grid-template-areas:
        "top-left . ."
        ". center ."
        ". . bottom-right";
}

.dice-3 .dot:nth-child(1) {
    grid-area: top-left;
}

.dice-3 .dot:nth-child(2) {
    grid-area: center;
}

.dice-3 .dot:nth-child(3) {
    grid-area: bottom-right;
}

.dice-4 .dice-dots {
    grid-template-areas:
        "top-left . top-right"
        ". . ."
        "bottom-left . bottom-right";
}

.dice-4 .dot:nth-child(1) {
    grid-area: top-left;
}

.dice-4 .dot:nth-child(2) {
    grid-area: top-right;
}

.dice-4 .dot:nth-child(3) {
    grid-area: bottom-left;
}

.dice-4 .dot:nth-child(4) {
    grid-area: bottom-right;
}

.dice-5 .dice-dots {
    grid-template-areas:
        "top-left . top-right"
        ". center ."
        "bottom-left . bottom-right";
}

.dice-5 .dot:nth-child(1) {
    grid-area: top-left;
}

.dice-5 .dot:nth-child(2) {
    grid-area: top-right;
}

.dice-5 .dot:nth-child(3) {
    grid-area: center;
}

.dice-5 .dot:nth-child(4) {
    grid-area: bottom-left;
}

.dice-5 .dot:nth-child(5) {
    grid-area: bottom-right;
}

.dice-6 .dice-dots {
    grid-template-areas:
        "top-left . top-right"
        "middle-left . middle-right"
        "bottom-left . bottom-right";
}

.dice-6 .dot:nth-child(1) {
    grid-area: top-left;
}

.dice-6 .dot:nth-child(2) {
    grid-area: top-right;
}

.dice-6 .dot:nth-child(3) {
    grid-area: middle-left;
}

.dice-6 .dot:nth-child(4) {
    grid-area: middle-right;
}

.dice-6 .dot:nth-child(5) {
    grid-area: bottom-left;
}

.dice-6 .dot:nth-child(6) {
    grid-area: bottom-right;
}

.dice-number {
    font-size: 14px;
    font-weight: 600;
    color: #606266;
    background: #f5f7fa;
    padding: 4px 8px;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
}
</style>